/**
 * Провайдер темы принимает тему приложения {@link GolfTheme} и после конвертации в {@link AppTheme} прокидывает
 * её с помощью styled-components/ThemeProvider  в приложение.
 * Позволяет получать текущую тему через styled-components/useTheme или пропом theme в самих стайледах
 */

import { golfToAppTheme } from 'application/theme/golf/golfToAppTheme'
import { useScreenWidth } from 'lib/use-screen-size'
import React, { FC, useMemo } from 'react'
import { ThemeProvider as StyledThemeProvider } from 'styled-components'

import { corvetteToAppTheme } from './corvette/corvetteToAppTheme'
import { CorvetteTheme } from './corvette/types'
import { GolfTheme } from './golf/types'

type ThemeProviderProps = { golfTheme?: GolfTheme; corvetteTheme?: CorvetteTheme }

export const ThemeProvider: FC<ThemeProviderProps> = ({ golfTheme, corvetteTheme, children }) => {
  const width = useScreenWidth()

  const appTheme = useMemo(() => {
    if (golfTheme) {
      return golfToAppTheme(golfTheme, width)
    }

    if (corvetteTheme) {
      return corvetteToAppTheme(corvetteTheme, width)
    }

    throw new Error(
      "No Corvette or Golf theme provided to ThemeProvider. That should not happen, ever. Check ThemeProvider's parent component"
    )
  }, [width])

  return <StyledThemeProvider theme={appTheme}>{children}</StyledThemeProvider>
}
